import axiosInstance from "./axios";

export const StartShopifyLink = (data) => {
  return axiosInstance.post("/account/startShopify", data);
};
export const IntegrateShopify = (data) => {
  return axiosInstance.post("/account/integrateShopify", data);
};
